export const CONTACT = {
  addressLines: ['Clifton', 'Bedfordshire'],
  office: '01582 616064',
  mobile: '07838 648097',
  whatsapp: '07838 648097',
  email: 'info@awaytomakkah.com',
};

export const SOCIAL_LINKS = [
  {
    id: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61590093074032',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/awaytomakkahh',
  },
];

export const HAJJ_PACKAGES = [
  {
    id: 'hajj-deluxe-2027',
    title: 'Deluxe Hajj Package 2027',
    tier: 'Deluxe',
    dates: 'Hajj 1448 / 2027',
    madinah: 'Emaar Royal Hotel Medina (or similar) — half board, near Masjid an-Nabawi',
    makkah:
      'Suites Almaqam (Mashaeer, full board, 15–20 min from Al-Jamarat) & Anjum Hotel Makkah (half board, steps from the Haram). Hotel shifting applies during Hajj.',
    includes: [
      'Return flight',
      'Hotels in Makkah & Madinah',
      'Complete Mashaeer support',
      'All ground transport',
      'Room sharing availability',
      'Expert guidance & 24/7 on-ground assistance',
      'Special assistance for Bangladesh passport holders',
    ],
    prices: { quad: 8749, triple: 9349, twin: 9949 },
    deposit: 1000,
    breakfast: false,
    mealNote: 'Half board & full board as per hotel itinerary',
    kids: 'Prices per person. Qurbani not included.',
    flightsNote: null,
    earlyBird: null,
  },
  {
    id: 'hajj-luxury-2027',
    title: 'Luxury Hajj Package 2027',
    tier: 'Luxury',
    dates: 'Hajj 1448 / 2027',
    madinah: 'Worth Peninsula Madinah (or similar) — half board, near Masjid an-Nabawi',
    makkah:
      'Suites Almaqam (Mashaeer, full board, 15–20 min from Al-Jamarat) & Hyatt Regency Jabal Omar (half board, steps from the Haram). Hotel shifting applies during Hajj.',
    includes: [
      'Return flight',
      'Hotels in Makkah & Madinah',
      'Complete Mashaeer support',
      'All ground transport',
      'Room sharing availability',
      'Expert guidance & 24/7 on-ground assistance',
      'Special assistance for Bangladesh passport holders',
    ],
    prices: { quad: 9849, triple: 10449, twin: 11449 },
    deposit: 1000,
    breakfast: false,
    mealNote: 'Half board & full board as per hotel itinerary',
    kids: 'Prices per person. Qurbani not included.',
    flightsNote: null,
    earlyBird: null,
  },
];

const FLIGHTS_NOT_INCLUDED =
  'Flights are not included with this package. Please call our agents for flights.';

export const UMRAH_PACKAGES = [
  {
    id: '4-star-aug-2026',
    title: '4 Star August Umrah Package 2026',
    tier: '4★',
    dates: '01 August – 30 August',
    madinah: '3 nights in 4* Shaza Regency Madinah',
    makkah: '4 nights in 4* Anjum Makkah',
    includes: [
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
    ],
    prices: { quad: 695, triple: 795, twin: 895 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: 'Kids under 6 yrs stay free with parents, incl. breakfast',
    flightsNote: FLIGHTS_NOT_INCLUDED,
    earlyBird: null,
  },
  {
    id: '5-star-aug-2026',
    title: '5 Star August Umrah Package',
    tier: '5★',
    dates: '01 August – 30 August',
    madinah: '4 nights in 5* Diyar al Ajwa Tapestry by Hilton Madinah',
    makkah: '5 nights in 5* Hilton Convention Makkah',
    includes: [
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
    ],
    prices: { quad: 799, triple: 899, twin: 899 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: 'Kids under 6 yrs stay free with parents, incl. breakfast',
    flightsNote: FLIGHTS_NOT_INCLUDED,
    earlyBird: null,
  },
  {
    id: '4-star-sept-2026',
    title: '4 Star September Umrah Package 2026',
    tier: '4★',
    dates: '05 September – 30 September',
    madinah: '3 nights in 4* Shaza Regency Madinah',
    makkah: '4 nights in 4* Emaar Grand Makkah',
    includes: [
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
    ],
    prices: { quad: 655, triple: 755, twin: 855 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: 'Kids under 6 yrs stay free with parents, incl. breakfast',
    flightsNote: FLIGHTS_NOT_INCLUDED,
    earlyBird: null,
  },
  {
    id: '5-star-sept-2026',
    title: '5 Star September Umrah Package 2026',
    tier: '5★',
    dates: '05 September – 30 September',
    madinah: '5 nights in 5* Worth Tharwat Madinah',
    makkah: '5 nights in 5* Pullman Zam Zam Makkah',
    includes: [
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
    ],
    prices: { quad: 795, triple: 895, twin: 995 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: 'Kids under 6 yrs stay free with parents, incl. breakfast',
    flightsNote: FLIGHTS_NOT_INCLUDED,
    earlyBird: null,
  },
  {
    id: 'oct-holidays-group-2026',
    title: 'October Holidays Umrah Group Package',
    tier: 'Group',
    dates: '24 October – 03 November',
    madinah: '5 nights in 4* Shaza Regency Madinah',
    makkah: '4 nights in 5* Hilton Convention Makkah',
    includes: [
      'Flights with Qatar Airways (2pc 35 kg luggage allowance)',
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
      'Fully qualified scholar',
    ],
    prices: { quad: 1395, triple: 1495, twin: 1695 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: 'Kids under 6 yrs stay free with parents, incl. breakfast',
    flightsNote: null,
    earlyBird: null,
  },
  {
    id: 'dec-holidays-group-2026',
    title: 'December Holidays Umrah Group Package',
    tier: 'Group',
    dates: '20 December – 30 December 2026',
    madinah: '5 nights in 4* Shaza Regency Madinah',
    makkah: '5 nights in 5* Hilton Convention Makkah',
    includes: [
      'Flights with Royal Jordan',
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
      'Fully qualified scholar',
    ],
    prices: { quad: 1700, triple: 1800, twin: 1900 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: 'Kids under 6 yrs stay free with parents, incl. breakfast',
    flightsNote: null,
    earlyBird: null,
  },
  {
    id: '4-star-jan-2027',
    title: '4 Star January Umrah Package 2027',
    tier: '4★',
    dates: '12 January – 30 January',
    madinah: '3 nights in 4* Shaza Regency Madinah',
    makkah: '4 nights in 4* Emaar Grand Makkah',
    includes: [
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
    ],
    prices: { quad: 695, triple: 795, twin: 895 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: 'Kids under 6 yrs stay free with parents, incl. breakfast',
    flightsNote: FLIGHTS_NOT_INCLUDED,
    earlyBird: null,
  },
  {
    id: '5-star-jan-2027',
    title: '5 Star January Umrah Package 2027',
    tier: '5★',
    dates: '12 January – 30 January',
    madinah: '5 nights in 5* Worth Peninsula',
    makkah: '5 nights in 5* Hilton Convention Makkah',
    includes: [
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'E-waiver visa (British passport)',
      'Full ground transport',
    ],
    prices: { quad: 795, triple: 895, twin: 995 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: 'Kids under 6 yrs stay free with parents, incl. breakfast',
    flightsNote: FLIGHTS_NOT_INCLUDED,
    earlyBird: null,
  },
  {
    id: 'ramadhan-2027-hotel',
    title: 'Ramadhan 2027 Umrah Hotel Package',
    tier: '5★',
    dates: '10 February 2026 – 20 February 2026',
    madinah: '5 nights in 4* Grand Plaza Al Badr Madinah',
    makkah: '5 nights in 5* Al Shohada Hotel Makkah',
    includes: [
      'Jummah in Makkah & Madinah',
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
    ],
    prices: { quad: 755, triple: 899, twin: 999 },
    deposit: 250,
    breakfast: false,
    mealNote: 'Sohoor included',
    kids: null,
    flightsNote: FLIGHTS_NOT_INCLUDED,
    earlyBird: null,
  },
  {
    id: 'easter-holidays-group-2027',
    title: 'Easter Holidays Umrah Group Package 2027',
    tier: 'Group',
    dates: '22 March – 01 April 2027',
    madinah: '5 nights in 4* Shaza Regency Madinah',
    makkah: '5 nights in 5* Hilton Convention Hotel Makkah',
    includes: [
      'Flights with Qatar Airways (35 kg luggage allowance)',
      'Guided ziyarah tours in Makkah',
      'Guided ziyarah tours in Madinah',
      'ETA visa (British passport)',
      'Full ground transport',
      'Fully qualified scholar',
    ],
    prices: { quad: 1395, triple: 1495, twin: 1695 },
    deposit: 250,
    breakfast: true,
    mealNote: null,
    kids: null,
    flightsNote: null,
    earlyBird: null,
  },
];

/** @deprecated Prefer HAJJ_PACKAGES and UMRAH_PACKAGES; kept as the full catalogue. */
export const PACKAGES = [...HAJJ_PACKAGES, ...UMRAH_PACKAGES];

export const HOTELS = [
  { id: '1', name: 'Al Marwa Rayhaan Rotana', priceText: 'From £189.99', image: '1.jpg' },
  { id: '2', name: 'Swissotel Makkah', priceText: 'Starting from £155.00 per night', image: '2.jpg' },
  { id: '3', name: 'Swissotel Al Maqam', priceText: 'Starting from £153.00 per night', image: '3.jpg' },
  { id: '4', name: 'Marriott Jabal Omar', priceText: 'Starting from £139.00 per night', image: '4.jpg' },
  { id: '5', name: 'Hilton Double Tree', priceText: 'Starting from £116.00 per night', image: '5.jpg' },
  { id: '6', name: 'Hilton Convention', priceText: 'Starting from £132.00 per night', image: '6.jpg' },
  { id: '7', name: 'Hilton Suites Makkah', priceText: 'Starting from £189.99 per night', image: '7.jpg' },
  { id: '8', name: 'Conrad Jabal Omar', priceText: 'Starting from £189.99 per night', image: '8.jpg' },
  { id: '9', name: 'Movenpick Hajar Tower', priceText: 'Starting from £165.00', image: '9.jpg' },
  { id: '10', name: 'Address Jabal Omar Makkah', priceText: 'From £175.99', image: '10.jpg' },
  { id: '11', name: 'Jumeirah Jabal Omar Makkah', priceText: 'From £175.99', image: '11.jpg' },
  { id: '12', name: 'Taiba Front Madinah', priceText: 'Starting from £115.00 per night', image: '12.jpg' },
  { id: '13', name: 'Anwar Al Movenpick', priceText: 'Starting from £135.00 per night', image: '13.jpg' },
  { id: '14', name: 'Emaar Royal Madinah', priceText: 'Starting from £99.00 per night', image: '14.jpg' },
  { id: '15', name: 'Elaf Taqwa Madinah', priceText: 'Starting from £115.00 per night', image: '15.jpg' },
  { id: '16', name: 'Private VIP Transport', priceText: 'Starting from £5.00', image: '16.jpg' },
];

export const WHY_CHOOSE = [
  'Over 15 years of trusted experience',
  'Personalised Umrah packages',
  'Local guides in Makkah & Madinah',
  'Dedicated customer support',
  'A service built on trust, care, and sincerity',
];

export const TESTIMONIALS = [
  {
    id: 't1',
    name: 'Ashuk Ahmed',
    quote:
      'Just returned from Umrah with a group of 24 family members, and it was truly an unforgettable experience.\n\nA huge thank you to Brother Kosir and his team, who were incredibly supportive right from the initial enquiry stage. He went above and beyond his duties to ensure our journey was smooth, safe, and memorable throughout.\n\nI would highly recommend him to anyone planning to go for Umrah or Hajj.',
    rating: 5,
  },
  {
    id: 't2',
    name: 'Saidul Rahman',
    quote:
      'Our experience with Away to Makkah Umrah was truly unforgettable.\nFrom the very beginning, Brother Kosir provided outstanding support. Every aspect of our Umrah journey was thoughtfully organised, allowing us to focus entirely on our worship without any stress or uncertainty.\n\nTravelling with children can often be challenging, but every single need was carefully considered and catered for. The arrangements were comfortable, well-planned, and suitable for all ages, giving us complete peace of mind throughout the journey.\n\nThe teams in Madinah and Makkah were equally exceptional—always helpful, attentive, and sincere in their service. Their dedication made us feel valued and genuinely cared for during our entire stay.\n\nA truly beautiful and spiritually uplifting experience from start to finish.',
    rating: 5,
  },
  {
    id: 't3',
    name: 'Amir Ali',
    quote:
      'Brother Kosir made my Umrah experience truly memorable and meaningful. As someone performing Umrah for the first time, I really appreciated how everything was made so simple, well-organised, and easy to follow—removing any uncertainty and allowing me to focus on the spiritual journey.\n\nHis kindness and thoughtfulness did not go unnoticed. We felt genuinely cared for every step of the way, and that is something I will always cherish.\n\nMay Allah reward him immensely, place endless barakah in his work, and allow his business to continue growing and benefiting others. Ameen.',
    rating: 5,
  },
  {
    id: 't4',
    name: 'Suto Miah',
    quote:
      'This is my second time using this company for Umrah, and Allahumma barik, the service has once again been exceptional—truly beyond expectations.\n\nFrom the initial booking and tickets to having all our documents prepared, everything was handled seamlessly. The teams in Makkah and Madinah were highly professional, responsive, and always available whenever we needed assistance.\n\nWe were warmly welcomed at the airport and smoothly transferred to our hotels, which made the entire experience feel well-organised and stress-free. The level of care and service throughout was outstanding.',
    rating: 5,
  },
  {
    id: 't5',
    name: 'Jahangir Ali',
    quote:
      'We had a great Umrah experience with Away to Makkah Umrah Services. From the start, they delivered an informative seminar that helped us feel prepared and confident for the journey ahead.\n\nEverything was taken care of—from transportation and accommodation to arranging tours and providing all the essentials—allowing us to focus fully on our worship.\n\nThe ground teams in Makkah and Madinah were especially wonderful—helpful, kind, and always ready to support us with a smile.\n\nMay Allah (SWT) reward them abundantly and continue to bless their efforts. Ameen.',
    rating: 5,
  },
];
